import ApiService from '@/_cactus_core/ApiService';
import type { ApiResponse } from '@/_cactus_core/ApiService';

export const useApiService = () => {
  return {
    ApiService,
  };
};

export type { ApiResponse };
